import InternalBusiness from '@/manager/business/models/internal-business.model';
import Provider from '@/manager/business/models/provider.model';

export interface State {
    internalBusinessList: InternalBusiness[];
    providerList: Provider[];
}

export const state: State = {
    internalBusinessList: [],
    providerList: [],
};
